import React from "react";
import styled from "styled-components";
import { Card, Progress, Typography, Space } from "antd";
import { AimOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const GoalCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;

  .ant-card-body {
    padding: 20px;
  }
`;

const GoalItem = styled.div`
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const GoalLabel = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  margin-bottom: 4px;
`;

const GoalValue = styled.div`
  color: white;
  font-size: 18px;
  font-weight: 600;
`;

const DailyGoalMarker = ({ 
  quotesTarget = 8, 
  quotesCurrent = 0,
  ordersTarget = 3,
  ordersCurrent = 0 
}) => {
  // Calculate progress - allow over 100% to show over-achievement
  const quotesProgress = (quotesCurrent / quotesTarget) * 100;
  const ordersProgress = (ordersCurrent / ordersTarget) * 100;
  
  // Determine if target is exceeded
  const quotesExceeded = quotesCurrent > quotesTarget;
  const ordersExceeded = ordersCurrent > ordersTarget;

  return (
    <GoalCard>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Title level={5} style={{ color: "white", margin: 0 }}>
          <AimOutlined /> Today's Target
        </Title>
        
        <GoalItem>
          <GoalLabel>Quotes to send</GoalLabel>
          <GoalValue>
            {quotesCurrent} / {quotesTarget}
            {quotesExceeded && (
              <Text style={{ fontSize: 12, marginLeft: 8, color: "#52c41a", fontWeight: 500 }}>
                ✓
              </Text>
            )}
          </GoalValue>
          <Progress
            percent={Math.min(quotesProgress, 100)}
            strokeColor={quotesExceeded ? "#52c41a" : "#fff"}
            trailColor="rgba(255, 255, 255, 0.3)"
            size="small"
            showInfo={false}
          />
        </GoalItem>

        <GoalItem>
          <GoalLabel>Orders to confirm</GoalLabel>
          <GoalValue>
            {ordersCurrent} / {ordersTarget}
            {ordersExceeded && (
              <Text style={{ fontSize: 12, marginLeft: 8, color: "#52c41a", fontWeight: 500 }}>
                ✓
              </Text>
            )}
          </GoalValue>
          <Progress
            percent={Math.min(ordersProgress, 100)}
            strokeColor={ordersExceeded ? "#52c41a" : "#fff"}
            trailColor="rgba(255, 255, 255, 0.3)"
            size="small"
            showInfo={false}
          />
        </GoalItem>
      </Space>
    </GoalCard>
  );
};

export default DailyGoalMarker;

